<template>
  <div class="gray-gradient-bottom0">
    <navbar :data="0" />
    <div id="not_found" class="d-flex justify-content-center align-items-center">
      <div v-if="$store.state.window > 992" class="row">
        <div class="col-lg-4 col-12 d-flex">
          <img class="image" src="../assets/icons/oopsLeft.svg">
        </div>
        <div class="col-lg-4 col-12">
          <div class="oops">Ooops!</div>
          <div class="page mt-1">{{$t('notFound')}}</div>
          <button class="back" @click="$router.push('/home')">{{$t('back')}}</button>
        </div>
        <div class="col-lg-4 col-12 d-flex justify-content-end">
          <img class="image" src="../assets/icons/OopsRight.svg">
        </div>
      </div>
      <div v-else class="row">
        <div class="col-12 d-flex">
          <img class="image" src="../assets/icons/oopsLeft.svg">
        </div>
        <div class="col-12 d-flex justify-content-end">
          <img class="image" src="../assets/icons/OopsRight.svg">
        </div>
        <div class="col-12">
          <div class="oops">Ooops!</div>
          <div class="page mt-1">{{$t('notFound')}}</div>
          <button class="back" @click="$router.push('/home')">{{$t('back')}}</button>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Navbar from './Navbar'
import Footer from '../components/core/Footer'
export default {
  name: 'NotFound',
  components: { Footer, Navbar }
}
</script>

<style scoped lang="scss">
@import "src/assets/sass/main";
#not_found {
  padding-top: 130px;
  padding-bottom: 3rem;
  min-height: calc(100vh - 286px);
  .image {
    width: 110%;
  }
  .oops {
    color: $--yellow;
    font-size: 95px;
    font-weight: bold;
  }
  .page {
    font-size: 22px; color: #1D1D1D;
  }
  .back {
    margin-top: 4rem;
    width: 260px; height: 65px;
    font-size: 18px; font-weight: bold; font-style: italic; color: #1D1D1D;
    border: 3px solid $--yellow; border-radius: 20px;
  }
}
@media screen and (max-width: 1400px){
  .oops {
    font-size: 85px!important;
  }
}
@media screen and (max-width: 992px){
  #not_found {
    .image {
      width: 50%!important;
    }
    .oops {
      font-size: 70px!important;
    }
    .page {
      font-size: 19px; color: #1D1D1D;
    }
    .back {
      width: 230px; height: 50px;
      font-size: 15px;
    }
  }
}
@media screen and (max-width: 550px){
  #not_found {
    .image {
      width: 75%!important;
    }
  }
}

</style>
